module.exports = __webpack_public_path__ + "img/teacher.c2d883e9.svg";